import React, { createContext, useContext, useState, useEffect } from 'react';
import { DEFAULT_TIME_RANGE } from '../constants/timeRanges';

const TimeRangeContext = createContext();
const STORAGE_KEY = 'verops_global_time_range';

export const useTimeRange = () => {
  const context = useContext(TimeRangeContext);
  if (!context) {
    throw new Error('useTimeRange must be used within a TimeRangeProvider');
  }
  return context;
};

const getStoredTimeRange = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored || DEFAULT_TIME_RANGE;
  } catch (error) {
    console.warn('Failed to read time range from localStorage:', error);
    return DEFAULT_TIME_RANGE;
  }
};

const setStoredTimeRange = (timeRange) => {
  try {
    localStorage.setItem(STORAGE_KEY, timeRange);
  } catch (error) {
    console.warn('Failed to save time range to localStorage:', error);
  }
};

export const TimeRangeProvider = ({ children }) => {
  const [timeRange, setTimeRangeState] = useState(() => getStoredTimeRange());

  const setTimeRange = (newTimeRange) => {
    setTimeRangeState(newTimeRange);
    setStoredTimeRange(newTimeRange);
  };

  useEffect(() => {
    const stored = getStoredTimeRange();
    if (stored !== timeRange) {
      setTimeRangeState(stored);
    }
  }, []);

  const value = {
    timeRange,
    setTimeRange
  };

  return (
    <TimeRangeContext.Provider value={value}>
      {children}
    </TimeRangeContext.Provider>
  );
};
